import React from 'react'
import classnames from 'classnames';
import PropTypes from 'prop-types'
import './Badges.scss'
import HrbTranslate from '../../language/HrbTranslate';
import { TicketType } from '../../../pages/vdo-ticket/services/TicketType';
import { WorkflowTasks } from '../../../pages/vdo-ticket/services/WorkflowTasks';
import { supportsPayment } from '../../../strategies/TicketTypeStrategy';

const StatusBadge = props => {

    const { workflowTask, status, className, ticketType } = props
   
    return (
        <div className={classnames('status-badge', status.split(' ').join('').toLowerCase(), className)}>
            {status === 'Failed' && !workflowTask &&
                <HrbTranslate text='Tickets.Tasks.TaskStatus.Failed' />
            }
            {status === 'Failed' && workflowTask &&
                <HrbTranslate text={`Tickets.Tasks.DisplayNames.${workflowTask}`} />
            }
            {status !== 'Failed' && (!supportsPayment(ticketType) || workflowTask !== WorkflowTasks.PAYMENT_RECEIVED) &&
                <HrbTranslate text={`Tickets.Tasks.DisplayNames.${workflowTask}`} />
            }
            {status !== 'Failed' && (supportsPayment(ticketType) && workflowTask === WorkflowTasks.PAYMENT_RECEIVED) &&
                <HrbTranslate text={`Tickets.Tasks.DisplayNames.${WorkflowTasks.PAYMENT_RECEIVED_RTE}_Header`} />
            }
        </div>)
}

StatusBadge.propTypes = {
    workflowTask: PropTypes.string,
    status: PropTypes.string.isRequired,
    className: PropTypes.string,
    ticketType: PropTypes.string
}

export default StatusBadge